import { Input } from 'antd';
import ClearIcon from './ClearIcon';

interface TextEditorCellProps {
  onChange?: (value?: string) => void;
  value?: string;
  prefixSymbol?: string;
  style?: React.CSSProperties;
  handleSubmit?: () => void;
  handleClear?: () => void;
  isEditable?: boolean;
}

export default function TextEditorCell(props: TextEditorCellProps) {

  const defaultValue = props.value === '-' ? undefined : props.value;

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      props?.onChange?.(e.target.value);

  };

  // Handle clear input
  const handleClear = () => {

    props?.onChange?.();
    props?.handleClear?.();
  };



  const TextInput = (
    <Input
      onChange={handleInputChange}
      defaultValue={defaultValue}
      allowClear={{
        clearIcon: <ClearIcon onClick={handleClear} />,
      }}
      prefix={props.prefixSymbol}
      style={props.style}
      placeholder="Enter text"
      disabled={!props.isEditable}
    />
  );

  return <>{TextInput}</>;
}
